import { Flex } from '@mantine/core'
import { RiSendPlaneFill } from '@remixicon/react'
import { TextInput } from '../../../../components'
import classes from './ChatInputBox.module.css'

export const ChatInputBox = () => {
  return (
    <Flex
      className='border w-auto rounded-lg'
      style={{ borderColor: 'var(--mantine-color-Neutral-2)' }}
      px={7}
      py={5}
    >
      <TextInput flex={1} classNames={classes} placeholder='Ask anything..' />
      <button className='rounded-full p-2 bg-[var(--color-background-gray)] text-[var(--mantine-color-Neutral-8)]'>
        <RiSendPlaneFill size={24} style={{ transform: 'rotate(45deg)' }} />
      </button>
    </Flex>
  )
}
